import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'

import MultiFileUploadWrapper from './../sections/multi-file-upload-wrapper'
import { DocumentGsForm } from '@app/utils/document-gs-form'

onDomLoad(($dom) => {
  $dom.trigger('multiFileUploadBehaviour')
})

$(document).on('multiFileUploadBehaviour', function () {
  const $dom = $(document)
  $dom.find("[data-behaviour~='multi-file-upload-wrapper']").each(function () {
    if ($(this).data('multiFileUploadInitialised')) return

    const data = $(this).data()
    const form = this.closest(
      "[data-behaviour~='multi-file-upload-wrapper-form']"
    )
    if (!form) return

    $(this).data('multiFileUploadInitialised', true)
    const $form = $(form)
    const paramsPrefix = data.paramsPrefix
    const documentsForm = new DocumentGsForm(form, paramsPrefix)

    const handleFileUploaded = ({ blob }, uuid) => {
      documentsForm.addInputs(uuid, blob.signed_id, blob.filename)
    }

    const handleFileRemoved = (uuid) => {
      $form.find(`[data-id="${uuid}"]`).remove()
    }

    const files = {}
    $form.find(`[name="${paramsPrefix}[id]"]`).each((_, input) => {
      const $input = $(input)
      const documentId = $input.data('id')
      const documentName = $input.data('name')
      const documentSize = $input.data('size')

      if (documentId) {
        files[documentId] = {
          file: {
            name: documentName,
            size: documentSize,
          },
          existing: true,
        }
      } else {
        // Handle file rendering after validation errors on the form
        const documentKey = $input.data('key')
        const documentType = $input.data('type')

        files[documentKey] = {
          file: {
            name: documentName,
            size: documentSize,
          },
          existing: false,
        }

        documentsForm.addInputs(
          documentKey,
          documentKey,
          documentName,
          documentType,
          documentSize
        )
        $input.remove()
      }
    })

    const app = createApp(MultiFileUploadWrapper, {
      accept: data.accept,
      onFileUploaded: handleFileUploaded,
      onFileRemoved: handleFileRemoved,
      files,
    })
    app.mount(this)

    this.addEventListener(
      'multiFileUploadTeardown',
      (event) => {
        app.unmount()
        $(event.currentTarget).removeData('multiFileUploadInitialised')
      },
      { once: true }
    )
  })
})
